(() => {
  if (window.CorsailleAnalytics) return;
  const sessionKey = 'corsaille:analytics-session:v1';
  let sessionId;
  const analyticsAllowed = () => {
    try {
      if (window.Shopify?.designMode === true) return false;
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch (_error) {
      return false;
    }
  };
  const getSessionId = () => {
    if (sessionId) return sessionId;
    try {
      let value = sessionStorage.getItem(sessionKey);
      if (!value) {
        value = `${Date.now().toString(36)}-${crypto.getRandomValues(new Uint32Array(1))[0].toString(36)}`;
        sessionStorage.setItem(sessionKey, value);
      }
      sessionId = value;
      return sessionId;
    } catch (_error) {
      return 'unavailable';
    }
  };
  const normalise = (value) => value == null ? undefined : String(value).slice(0, 180);
  const numeric = (value) => Number.isFinite(Number(value)) ? Number(value) : undefined;
  const first = (detail, ...keys) => {
    for (const key of keys) {
      if (detail[key] !== undefined && detail[key] !== null && detail[key] !== '') return detail[key];
    }
    return undefined;
  };
  const allowedExtras = new Set([
    'action', 'appended_count', 'checked', 'destination', 'error_code', 'error_stage', 'filter',
    'filter_value', 'milestone', 'page', 'property_names', 'provider', 'quantity', 'reason',
    'result_count', 'sort_state', 'total_count', 'trigger', 'value',
  ]);
  const emit = (name, detail = {}) => {
    if (typeof window.CorsailleTrack !== 'function' || !analyticsAllowed()) return false;
    const payload = {
      route: location.pathname,
      currency: window.Shopify?.currency?.active,
      session_id: getSessionId(),
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      source: normalise(detail.source || document.body.dataset.template),
      category: normalise(detail.category),
      collection: normalise(detail.collection),
      collection_id: normalise(first(detail, 'collectionId', 'collection_id')),
      product_id: normalise(first(detail, 'productId', 'product_id')),
      product_title: normalise(first(detail, 'productTitle', 'product_title')),
      product_handle: normalise(first(detail, 'productHandle', 'product_handle')),
      variant_id: normalise(first(detail, 'variantId', 'variant_id')),
      object_type: normalise(first(detail, 'objectType', 'object_type')),
      module_id: normalise(first(detail, 'moduleId', 'module_id')),
      media_type: normalise(first(detail, 'mediaType', 'media_type')),
      position: numeric(detail.position),
    };
    allowedExtras.forEach((key) => {
      if (!(key in detail)) return;
      payload[key] = ['appended_count', 'milestone', 'page', 'quantity', 'result_count', 'total_count'].includes(key)
        ? numeric(detail[key])
        : key === 'property_names' && Array.isArray(detail[key])
          ? detail[key].map(normalise).filter(Boolean).slice(0, 20)
        : typeof detail[key] === 'boolean'
          ? detail[key]
          : normalise(detail[key]);
    });
    Object.keys(payload).forEach((key) => payload[key] === undefined && delete payload[key]);
    return window.CorsailleTrack(String(name).replace(/^corsaille_/, ''), payload) === true;
  };
  window.CorsailleAnalytics = Object.freeze({ emit });
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-cs-track]');
    if (!target) return;
    const product = target.closest('[data-cs-product-id], [data-product-id]') || target;
    emit(target.dataset.csTrack, {
      productId: target.dataset.csProductId || target.dataset.productId || product.dataset.csProductId || product.dataset.productId,
      productTitle: target.dataset.csProductTitle || target.dataset.productTitle || product.dataset.csProductTitle || product.dataset.productTitle,
      productHandle: target.dataset.csProductHandle || target.dataset.productHandle || product.dataset.csProductHandle || product.dataset.productHandle,
      variantId: target.dataset.csVariantId || target.dataset.variantId || product.dataset.csVariantId || product.dataset.variantId,
      category: target.dataset.category || product.dataset.family,
      collection: target.dataset.csCollection || product.dataset.csCollection,
      objectType: target.dataset.csObjectType || product.dataset.csObjectType,
      moduleId: target.dataset.csModuleId,
      mediaType: target.dataset.csMediaType,
      position: target.dataset.csPosition || target.dataset.position,
      source: target.dataset.source,
      destination: target.href ? new URL(target.href, location.href).pathname : undefined,
    });
  });
})();
